export function sortByUpdatedAtDesc<T extends { updatedAt?: string | Date | null }>(
  items: T[]
): T[] {
  return [...items].sort((a, b) => {
    const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
    const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
    return bTime - aTime;
  });
}

export function takeMostRecent<T extends { updatedAt?: string | Date | null }>(
  items: T[],
  limit: number
): T[] {
  return sortByUpdatedAtDesc(items).slice(0, limit);
}
